/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceDto } from '../../models/case-resource-dto';

export interface GetCaseResourceByRecipientGuid$Params {
  recipientGuid: string;
}

export function getCaseResourceByRecipientGuid(http: HttpClient, rootUrl: string, params: GetCaseResourceByRecipientGuid$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseResourceDto>> {
  const rb = new RequestBuilder(rootUrl, getCaseResourceByRecipientGuid.PATH, 'get');
  if (params) {
    rb.path('recipientGuid', params.recipientGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseResourceDto>;
    })
  );
}

getCaseResourceByRecipientGuid.PATH = '/case-resources/by-recipient/{recipientGuid}';
